import { type User } from '../../../../contexts/authContext/types/user.type';
import { APPLICATION_STATUS_TYPE } from '../../../../utils';

export const drcApproveToDoFilter = (user: User | null): any => {
  const { userInfo } = user ?? {};
  const { department, netId = '' } = userInfo ?? {};

  return {
    status: {
      in: [APPLICATION_STATUS_TYPE.UNDER_DSRC],
    },
    /** TODO   netId === '' to be removed, FOR TESTING */
    ...(netId === '' || department === 'GS'
      ? null
      : {
          programmeChoice: {
            department: { eq: department },
          },
        }),
  };
};
